module.exports = __webpack_public_path__ + "static/media/yellow_image2.4a0d6752.webp";